import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { RequestTaskService } from 'app/services/models/request-task.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-request-task-list',
  templateUrl: './request-task-list.component.html',
  styleUrls: ['./request-task-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RequestTaskListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;
  isSwitch = false;
  status = null;
  constructor(private requestTaskService: RequestTaskService, private _coreSidebarService: CoreSidebarService,private router:Router) {
    this.calculateDates();
  }

  async ngOnInit() {
    this.requestTaskService.event$.subscribe(async result => {
      await this.getAllRequest(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status, this.selectedDate);
    });
    await this.getAllRequest(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status, this.selectedDate);
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {

      this.router.navigate([`/admin/request-task/${event.row.id}`]);
    }
  }

  async getAllRequest(page, size, search, status, date) {
    this.blockUI.start("Talepler yükleniyor..");
    const data = await this.requestTaskService.getAllRequestTask(page, size, search, status, date);
    console.log(data);
    this.rows = data.requestTasks;
    this.totalCount = data.totalCount;
    this.blockUI.stop();
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {
      await this.getAllRequest(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status, this.selectedDate);
    }, 500);
  }

  async onPageChange() {
    await this.getAllRequest(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status, this.selectedDate);
  }

  today: string;
  lastWeek: string;
  lastMonth: string;
  lastThreeMonths: string;
  lastSixMonths: string;
  lastYear: string;
  selectedDate: string = null;

  calculateDates() {
    const currentDate = new Date();

    // Bugünün tarihi
    this.today = this.formatDate(currentDate);

    // Son 1 hafta (Bugünden geriye 7 gün)
    const lastWeekDate = new Date();
    lastWeekDate.setDate(currentDate.getDate() - 7);
    this.lastWeek = this.formatDate(lastWeekDate);

    // Son 1 ay (O ayın başı)
    const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    this.lastMonth = this.formatDate(lastMonthDate);

    // Son 3 ay (Bulunduğumuz aydan geriye 3 ay)
    const lastThreeMonthsDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 3, 1);
    this.lastThreeMonths = this.formatDate(lastThreeMonthsDate);

    // Son 6 ay (Bulunduğumuz aydan geriye 6 ay)
    const lastSixMonthsDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 6, 1);
    this.lastSixMonths = this.formatDate(lastSixMonthsDate);

    // Son 1 yıl (Bulunduğumuz yıldan geriye 1 yıl)
    const lastYearDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), 1);
    this.lastYear = this.formatDate(lastYearDate);
  }

  formatDate(date: Date): string {
    // Tarihi "yyyy-MM-dd" formatına çeviriyoruz
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ayları iki haneli olacak şekilde ayarla
    const day = ('0' + date.getDate()).slice(-2); // Günleri iki haneli yap
    return `${year}-${month}-${day}`;
  }

  async onOptionDateChange() {
    // Tarih değiştiğinde yapılacak işlemler buraya
    await this.getAllRequest(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status, this.selectedDate);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllRequest(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status, this.selectedDate);
  }

  async onSwitchChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.isSwitch = isChecked;
    if (this.isSwitch) {
      this.status = 4;
    } else {
      this.status = null;
    }
    await this.getAllRequest(this.pageBasic - 1, this.selectedSize, this.searchValue, this.status, this.selectedDate);
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Talep Oluşturuldu';
      case 2:
        return 'Yapılıyor';
      case 3:
        return 'İptal Edildi';
      case 4:
        return 'Tamamlandı';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-glow badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-glow badge-warning';  // Danger class for status 2
      case 3:
        return 'badge badge-glow badge-danger'; // Success class for status 3
      case 4:
        return 'badge badge-glow badge-success'; // Warning class for status 4
      default:
        return 'badge badge-glow badge-secondary'; // Secondary class for unknown status
    }
  }

  requestTaskId: any;
  toggleSidebar(name, id): void {
    this.requestTaskId = id
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }
}